// Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import DrawerToggle from '../drawer-toggle/drawer-toggle';
import Expandable, { trackingPropTypes } from '../expandable/expandable';

// Helpers
import getValidColor from '../../lib/get-valid-color';

/**
 * Layout component. Renders a top component, an expanded section, and a
 * a product details toggle to control the expansion. Fires tracking on open
 * and close.
 *
 * param {array} children - first child is element to show always, second is element to show in expansion
 * param {string} topElementClassName - classname for top element
 * param {string} drawerElementClassName - classname for drawer element cont
 */
class ExpandingRow extends Component {
  constructor(props) {
    super(props);
    this.scrollIntoView = this.scrollIntoView.bind(this);
  }

  scrollIntoView() {
    // `animatedScrollTo` only executes on client side
    const animatedScrollTo = require('animated-scrollto'); // eslint-disable-line

    const headerHeight = 70;
    const cardOffsetTop = this.expandingRow.getBoundingClientRect().top;
    const y = cardOffsetTop + window.pageYOffset - headerHeight;

    animatedScrollTo(document.body, y, 300);
    animatedScrollTo(document.documentElement, y, 300);
  }

  render() {
    const {
      children: [overview, details],
      shouldScroll,
      defaultOpen,
      ...otherProps
    } = this.props;
    const expandedInlineStyle = {
      backgroundColor: getValidColor(this.props.expandedBackgroundColor),
    };

    return (
      <Expandable
        trackingData={otherProps}
        isExpanded={defaultOpen}
        afterToggle={(isExpanded) => {
          if (!isExpanded && shouldScroll && this.expandingRow) {
            this.scrollIntoView();
          }
        }}
        render={(toggleExpanded, isExpanded) => (
          <div
            className={`expanding-row__wrapper expanding-row__${
              isExpanded ? 'open' : 'closed'
            }`}
            style={isExpanded ? expandedInlineStyle : null}
          >
            <div
              className={this.props.topElementClassName}
              ref={(c) => {
                this.expandingRow = c;
              }}
            >
              {overview}
            </div>
            <div className={this.props.drawerElementClassName}>
              {isExpanded ? details : null}
              <div className="toggle-expanded-after-product">
                <DrawerToggle
                  onClick={toggleExpanded}
                  isExpanded={isExpanded}
                  openText={this.props.openText}
                  closedText={this.props.closedText}
                />
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ExpandingRow.displayName = 'ExpandingRow';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ExpandingRow.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  topElementClassName: PropTypes.string,
  drawerElementClassName: PropTypes.string,
  expandedBackgroundColor: PropTypes.string,
  openText: PropTypes.string,
  closedText: PropTypes.string,
  shouldScroll: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  ...trackingPropTypes,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ExpandingRow.defaultProps = {
  expandedBackgroundColor: '',
  openText: 'Hide Details',
  closedText: 'Show Details',
  shouldScroll: true,
};

export default ExpandingRow;
